import React from 'react';

import { SelectProps as AntdSelectProps } from 'antd/lib/select';

import { JuridictionResponseDto } from 'lib_api/lib/api/gen';

import BaseSelectWithQuery from 'components/BaseForm/Select/BaseSelectWithQuery';
import { useGetJuridictionQuery } from 'hooks/juridiction/useGetJuridictionQuery';

export default function BaseSelectJuridiction(props: AntdSelectProps) {
  const { query, setSearched } = useGetJuridictionQuery();

  return (
    <BaseSelectWithQuery
      query={query}
      setSearched={setSearched}
      allowClear
      getOptionLabel={(juridiction: JuridictionResponseDto) =>
        juridiction.libelle
      }
      getOptionValue={(juridiction: JuridictionResponseDto) =>
        juridiction.idCorrelation
      }
      {...props}
    />
  );
}
